import * as l from "react";
const a = (e) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "DO_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ l.createElement("g", { mask: "url(#DO_svg__a)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "DO_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ l.createElement("g", { mask: "url(#DO_svg__b)" }, /* @__PURE__ */ l.createElement("path", { fill: "#4257BF", d: "M0 0h14v10H0zM18 14h14v10H18z" }), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 0h6v9h13v6H19v9h-6v-9H0V9h13V0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.867 10.526c-.038-.175-.08-.392-.08-.392-.096.23-.125.44-.087.628l-.11.166c-.101-.143-.229-.412-.229-.412.005.078.003.158 0 .235-.004.182-.008.352.072.458l-.046.106c-.11-.117-.293-.329-.293-.329.014.254.08.454.2.597-.022.074-.04.148-.054.221l-.181-.202c.013.23.05.384.143.512a2.115 2.115 0 00-.003.11l-.197-.22a.84.84 0 00.22.539c.013.077.029.154.049.23l.011.042a25.798 25.798 0 01-.286-.153c.09.212.22.33.364.415.032.099.065.194.1.285-.16-.05-.4-.13-.4-.13a.85.85 0 00.5.37 3.9 3.9 0 00.117.24c-.152-.048-.332-.109-.332-.109.14.214.306.308.483.364.117.178.243.324.374.433-.15.063-.345.139-.345.139a.835.835 0 00.54-.008l.01.005c.064.033.134.063.214.093-.124.051-.244.098-.244.098.21.064.378.047.53-.004l.008.002.24.066.218.058c.152.04.239.07.28.095l.009.005.001.001s.001 0 0 0l.117-.09a.174.174 0 00-.056-.05 1.368 1.368 0 00-.316-.11 51.795 51.795 0 00-.222-.059 9.868 9.868 0 01-.233-.064l-.055-.016a.834.834 0 00-.124-.516s-.038.293-.065.454a2.035 2.035 0 01-.3-.135.834.834 0 00-.213-.498s.008.181.013.339a2.022 2.022 0 01-.283-.356l.085.047a.86.86 0 00-.217-.61s.009.198.013.36a3.939 3.939 0 01-.153-.321.835.835 0 00-.027-.548l-.084.26a5.31 5.31 0 01-.037-.109.851.851 0 00.104-.615s-.105.202-.185.348l-.016-.06a1.944 1.944 0 01-.042-.197.843.843 0 00.283-.52s-.18.166-.306.276a1.965 1.965 0 01.002-.168.838.838 0 00.35-.45s-.181.114-.322.2c.01-.055.022-.11.036-.166a.858.858 0 00.414-.49s-.18.116-.32.201a1.973 1.973 0 01.166-.338.835.835 0 00.426-.334l-.261.08c.074-.108.161-.228.261-.362l-.112-.096-.117.159zM17.914 10.526c.038-.175.08-.392.08-.392.096.23.125.44.087.628l.11.166c.102-.143.229-.412.229-.412a2.885 2.885 0 000 .235c.004.182.008.352-.072.458.016.036.032.071.046.106.11-.117.293-.329.293-.329-.014.254-.08.454-.2.597.022.074.04.148.054.221l.181-.202c-.013.23-.049.384-.143.512.002.037.003.073.003.11l.197-.22a.84.84 0 01-.22.539 2.143 2.143 0 01-.048.23l-.012.042.286-.153a.836.836 0 01-.364.415 5.471 5.471 0 01-.1.285c.16-.05.4-.13.4-.13a.85.85 0 01-.5.37 3.959 3.959 0 01-.117.24c.152-.048.333-.109.333-.109a.846.846 0 01-.484.364 1.963 1.963 0 01-.374.433c.15.063.345.139.345.139a.835.835 0 01-.54-.008l-.01.005a2.04 2.04 0 01-.214.093c.124.051.244.098.244.098a.834.834 0 01-.53-.004l-.008.002-.24.066-.218.058a1.343 1.343 0 00-.289.1l-.001.001-.117-.09a.174.174 0 01.056-.05c.058-.034.15-.065.316-.11l.222-.059.234-.064.054-.016a.834.834 0 01.124-.516s.039.293.065.454a2.027 2.027 0 00.3-.135.834.834 0 01.213-.498s-.008.181-.012.339c.097-.096.192-.215.282-.356l-.085.047c0-.2.037-.4.217-.61l-.013.36c.054-.1.105-.207.153-.321a.835.835 0 01.028-.548s.04.129.083.26a5.31 5.31 0 00.037-.109.85.85 0 01-.104-.615s.105.202.185.348l.016-.06c.018-.065.032-.13.042-.197a.843.843 0 01-.283-.52s.18.166.306.276a1.965 1.965 0 00-.002-.168.838.838 0 01-.35-.45s.181.114.322.2a2.241 2.241 0 00-.036-.166.857.857 0 01-.414-.49s.18.116.321.201a1.973 1.973 0 00-.166-.338.834.834 0 01-.427-.334l.261.08a11.264 11.264 0 00-.261-.362l.112-.096.117.159z",
      fill: "#5AB92D"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M13.252 9.316c.4-.28 1.133-.523 1.51-.523.002 0 .006-.001.016-.006.032-.013.238-.14.251-.148.267-.152.545-.233.925-.233v.667c-.273 0-.45.051-.63.153.032-.017-.235.148-.32.183a.625.625 0 01-.242.05c-.253 0-.866.203-1.166.414-.107.075-.097.052-.094.097.012.164 0 .264-.101.393-.013.016-.034.108-.036.269l-.625-.008c.003-.263.043-.47.137-.625-.013-.27.081-.476.375-.683z",
      fill: "#003994"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M13.587 9.565l-.07-.11c.321-.227.62-.341.898-.341a.903.903 0 00.319-.072c.082-.031.165-.07.278-.128.407-.207.418-.212.526-.212h.369v.133h-.369c-.078 0-.103.012-.473.2a3.07 3.07 0 01-.288.132c-.135.052-.253.08-.362.08-.25 0-.527.105-.828.318z",
      fill: "#EBCA5E"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M18.5 9.316c-.4-.28-1.133-.523-1.51-.523-.002 0-.006-.001-.016-.006-.032-.013-.238-.14-.251-.148a1.754 1.754 0 00-.925-.233v.667c.273 0 .45.051.63.153-.032-.017.235.148.32.183.079.033.158.05.242.05.253 0 .866.203 1.166.414.107.075.097.052.094.097-.012.164 0 .264.101.393.013.016.034.108.036.269l.625-.008c-.003-.263-.043-.47-.138-.625.014-.27-.08-.476-.374-.683z",
      fill: "#003994"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M18.115 9.565l.069-.11c-.321-.227-.62-.341-.898-.341a.904.904 0 01-.319-.072 2.956 2.956 0 01-.277-.128c-.408-.207-.42-.212-.527-.212h-.368v.133h.368c.078 0 .103.012.473.2.115.059.202.1.289.132.134.052.252.08.361.08.25 0 .527.105.829.318z",
      fill: "#EBCA5E"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M13.823 10.02l.326.354v1.473h.33v.094l.482.231s.072-.974-.154-1.23c-.227-.257.154-.32.154-.32l.578.579V10.02h-1.716z",
      fill: "#003994"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M17.74 10.02l-.327.354v1.473h-.33v.094l-.481.231s-.073-.974.154-1.23c.226-.257-.154-.32-.154-.32l-.579.579V10.02h1.716z",
      fill: "#D62818"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M14.877 10.597l-.05.06.963.89.051-.004.796-.888-.055-.056-.77.862-.935-.864z",
      fill: "#FFC300"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M14.742 10.97l-.063.061 1.228.89.066-.003 1.015-.89-.069-.055-.984.862-1.193-.864z",
      fill: "#FFC300"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M14.178 12.422h.422l.288.088s.093.66.555.66l.076.847-.358-.194s-.234.103-.273.103c-.04 0-.372.187-.372 0 0-.186-.338-.488-.338-.488v-1.016z",
      fill: "#D62818"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M17.52 12.422h-.423l-.288.088s-.092.66-.555.66l-.076.847.359-.194s.233.103.272.103c.04 0 .372.187.372 0 0-.186.338-.488.338-.488v-1.016z",
      fill: "#003994"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M16.615 12.502h.5c0 .374-.132.677-.392.882l-.297-.428c.127-.101.19-.243.19-.454zM15.305 11.474v.7h.581s-.055.527-.055.859c0 .331.055.762.055.762s.142-.071.142-.52v-1.149l.46.049-.049-.633h-.194s.298.395 0 .395c-.297 0-.64.077-.705.077-.065 0-.235-.54-.235-.54z",
      fill: "#D62818"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M15.811 12.321s-.327.193-.327.506.164.67.164.67-.078-.705.043-.893c.12-.187.12-.283.12-.283zM15.28 12.553s-.019.226.115.226c.135 0-.115-.226-.115-.226z",
      fill: "#003994"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M16.428 11.944l.052.179-.855.28-.191-.796.17-.046.145.606.68-.223z",
      fill: "#373737"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.037 15.41l-.075.063a.783.783 0 01-.065-.102.833.833 0 01-.204-.101c-.082-.057-.165-.057-.271.005l-.121-.233c.184-.109.367-.109.53.005a.119.119 0 00.005.004.482.482 0 01.258-.333c.254-.145 1.37-.298 1.708-.298v.427c-.275 0-1.342.146-1.52.247l-.015.008c-.023.014-.036.02-.038.03-.002.008.003.018.015.035.01 0 .017-.003.02-.006l.177.188c-.074.08-.237.093-.404.06zm-1.195.007s.37.325.636.246c.267-.079.35-.167.35-.167s-.267-.036-.55-.079c-.282-.043-.436 0-.436 0z",
      fill: "#D62818"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.066 15.18l.045-.064c-.132-.106-.097-.165.156-.222a7.984 7.984 0 011.615-.19v-.08c-.48 0-1.07.072-1.564.177l-.067.015c-.305.068-.384.204-.184.364zm.252-.379l.015.079a7.965 7.965 0 011.549-.176v-.08c-.482 0-1.076.073-1.564.177z",
      fill: "#EBCA5E"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.465 15.41l.075.063a.773.773 0 00.065-.102.832.832 0 00.204-.101c.081-.057.165-.057.271.005l.121-.233c-.184-.109-.367-.109-.53.005l-.005.004a.482.482 0 00-.258-.333c-.254-.145-1.37-.298-1.708-.298v.427c.275 0 1.342.146 1.52.247l.015.008c.023.014.036.02.038.03.002.008-.003.018-.015.035-.01 0-.017-.003-.02-.006l-.177.188c.074.08.237.093.404.06zm1.195.007s-.37.325-.636.246c-.267-.079-.35-.167-.35-.167s.267-.036.55-.079c.282-.043.436 0 .436 0z",
      fill: "#D62818"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.435 15.18l-.045-.064c.132-.106.098-.165-.155-.222a7.984 7.984 0 00-1.615-.19v-.08c.48 0 1.07.072 1.564.177l.067.015c.305.068.384.204.184.364zm-.251-.379l-.015.079a7.963 7.963 0 00-1.549-.176v-.08a8.04 8.04 0 011.564.177z",
      fill: "#EBCA5E"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M15.366 15.511l-.194-.342c.177-.114.404-.169.68-.169.277 0 .502.055.673.172l-.202.336c-.103-.07-.26-.108-.471-.108-.213 0-.374.039-.486.111z",
      fill: "#D62818"
    }
  )))
);
export {
  a as default
};
